__turbopack_context__.v({
  "addAction": "EditableList-module__FWMiza__addAction",
  "addBtn": "EditableList-module__FWMiza__addBtn",
  "bullet": "EditableList-module__FWMiza__bullet",
  "container": "EditableList-module__FWMiza__container",
  "deleteBtn": "EditableList-module__FWMiza__deleteBtn",
  "editableItem": "EditableList-module__FWMiza__editableItem",
  "editableText": "EditableList-module__FWMiza__editableText",
  "itemContent": "EditableList-module__FWMiza__itemContent",
  "list": "EditableList-module__FWMiza__list",
  "listItem": "EditableList-module__FWMiza__listItem",
});
